/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=Symbol("hasTransparencyModeSymbol");function o(o){return n in o}export{n as hasTransparencyModeSymbol,o as isSymbolLayerWithTransparencyMode};
